import {
  AddCardOutlined,
  CategoryOutlined,
  DashboardOutlined,
  GavelOutlined,
  InventoryOutlined,
  LockResetOutlined,
  Newspaper,
  NotificationAddOutlined,
  PersonOutlineOutlined,
  SettingsOutlined,
  ArticleOutlined,
  FileCopyOutlined,
  FolderSharedOutlined,
  FormatListBulletedOutlined,
  ListAltOutlined,
  ViewListOutlined,
  BallotOutlined,
  PaymentsOutlined,
  QuizOutlined,
  GroupOutlined,
  Business,
  // EditCalendarOutlined,
} from "@mui/icons-material";

import { MailOpen, ShoppingBag, Tag, Ticket, User } from "lucide-react";
import React from "react";

export const navSections = [
  // ===== Dashboard =====
  {
    label: "Dashboard",
    icon: React.createElement(DashboardOutlined),
    path: "/admin/dashboard",
    type: "single",
  },

  // ===== Users & Access =====
  {
    label: "Users",
    icon: React.createElement(User),
    path: "/admin/users",
    type: "single",
  },
  // {
  //   label: "Seller Request List",
  //   icon: React.createElement(ContactSupportOutlined),
  //   path: "/admin/seller-request",
  //   type: "single",
  // },
  {
    label: "Subscribers",
    icon: React.createElement(MailOpen),
    path: "/admin/subscribers-list",
    type: "single",
  },

  // ===== Business / Marketplace =====
  {
    label: "Approved Companies",
    icon: React.createElement(Business),
    path: "/admin/companies",
    type: "single",
  },
  {
    label: "Brands",
    icon: React.createElement(FolderSharedOutlined),
    items: [
      {
        label: "Brand List",
        icon: React.createElement(FormatListBulletedOutlined, {
          fontSize: "small",
        }),
        path: "/admin/brand-list",
      },
    ],
  },
  {
    label: "Machineries",
    icon: React.createElement(ShoppingBag),
    items: [
      {
        label: "Machinery List",
        icon: React.createElement(BallotOutlined, { fontSize: "small" }),
        path: "/admin/machineries",
      },
      {
        label: "Categories List",
        icon: React.createElement(ViewListOutlined, { fontSize: "small" }),
        path: "/admin/machinery-categories-list",
      },
      {
        label: "Sub-categories List",
        icon: React.createElement(ListAltOutlined, { fontSize: "small" }),
        path: "/admin/machinery-sub-categories-list",
      },
      {
        label: "Update Request List",
        icon: React.createElement(BallotOutlined, { fontSize: "small" }),
        path: "/admin/machinery-update-requests",
      },
    ],
  },
  {
    label: "Auction List",
    icon: React.createElement(GavelOutlined),
    path: "/admin/auctions-request",
    type: "single",
  },

  // ===== Plans & Payments =====
  {
    label: "Plans",
    icon: React.createElement(Ticket),
    items: [
      {
        label: "Plan List",
        icon: React.createElement(FormatListBulletedOutlined, {
          fontSize: "small",
        }),
        path: "/admin/plans",
      },
      // {
      //   label: "User Subscriptions",
      //   icon: React.createElement(GroupOutlined, {
      //     fontSize: "small",
      //   }),
      //   path: "/admin/user-subscriptions",
      // },
    ],
  },
  {
    label: "Payments",
    icon: React.createElement(PaymentsOutlined),
    path: "/admin/payments",
    type: "single",
  },
  {
    label: "Invoices",
    icon: React.createElement(FileCopyOutlined),
    path: "/admin/invoices",
    type: "single",
  },

  // ===== Content =====
  {
    label: "Blogs",
    icon: React.createElement(InventoryOutlined),
    items: [
      {
        label: "Blog",
        icon: React.createElement(InventoryOutlined),
        path: "/admin/blog",
      },
      {
        label: "Categories",
        icon: React.createElement(CategoryOutlined),
        path: "/admin/categories",
      },
    ],
  },
  {
    label: "News",
    icon: React.createElement(Newspaper),
    items: [
      {
        label: "All News",
        icon: React.createElement(ArticleOutlined),
        path: "/admin/news/all",
      },
      {
        label: "Categories",
        icon: React.createElement(CategoryOutlined),
        path: "/admin/news/categories",
      },
      {
        label: "Tags",
        icon: React.createElement(Tag),
        path: "/admin/news/tags",
      },
    ],
  },
  {
    label: "Faqs",
    icon: React.createElement(QuizOutlined),
    path: "/admin/faq-list",
    type: "single",
  },

  // ===== Support =====
  {
    label: "Support",
    icon: React.createElement(GroupOutlined),
    path: "/admin/support",
    type: "single",
  },

  // ===== Settings =====
  {
    label: "Settings",
    icon: React.createElement(SettingsOutlined),
    items: [
      {
        label: "Personal Info",
        icon: React.createElement(PersonOutlineOutlined, {
          fontSize: "small",
        }),
        path: "/admin/profile",
      },
      {
        label: "Change Password",
        icon: React.createElement(LockResetOutlined, {
          fontSize: "small",
        }),
        path: "/admin/change-password",
      },
      {
        label: "Policies",
        icon: React.createElement(AddCardOutlined, {
          fontSize: "small",
        }),
        path: "/admin/policies",
      },
      {
        label: "Notification",
        icon: React.createElement(NotificationAddOutlined, {
          fontSize: "small",
        }),
        path: "/admin/notifications",
      },
    ],
  },
];